<div class="ui-g-12">

    <h3>{{ tipo }}</h3>
    <hr>
    <div class="col-sm-12 no-padding">
        <button class="btn btn-app" pTooltip="Listar" tooltipPosition="top" (click)="mostraRouter()"  [routerLink]="['listar']"
            routerLinkActive="btn-app-active">
        <i class="fa fa-list"></i> Listar
        </button>
        <button class="btn btn-app" pTooltip="Novo Parecer" tooltipPosition="top" (click)="verificaExiteParecer()"
            routerLinkActive="btn-app-active">
        <i class="fa fa-edit"></i> Emitir 
        </button>
        <hr>
    </div>

    <router-outlet *ngIf="mostraEmitirAnalise"></router-outlet>

</div>